module.exports = __webpack_public_path__ + "img/Randy Wood.8fcff23e.jpg";